import { render, staticRenderFns } from "./LAttributeEditorComponent.vue?vue&type=template&id=3c5dea36&scoped=true"
import script from "./LAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./LAttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dea36",
  null
  
)

export default component.exports